export const spacing = {
  extraSmall: "4px",
  small: "8px",
  tiny: "12px",
  medium: "16px",
  large: "32px",
  larger: "40px",
  extraLarge: "100px",
};

export const font = {
  defaultLight: "Inter_300Light",
  defaultRegular: "Inter_400Regular",
  defaultMedium: "Inter_500Medium",
  defaultSemiBold: "Inter_600SemiBold",
  defaultBold: "Inter_700Bold",
};

export const wpdColor = {
  // Primary
  primary: "#2F7FF9",
  primaryDark: "#165cbc",
  primaryLight: "#85a6fb",

  primaryContrast: "#c0cefd",
  primaryContrastLight: "#ebf3ff",
  primaryContrastLighter: "#f9fbff",

  // Secondary
  secondary: "#756CFA",
  secondaryDark: "#4935f7",
  secondaryLight: "#9f9afc",

  secondaryContrast: "#c9c7fd",
  secondaryContrastLight: "#f0effe",

  // Tertiary
  tertiary: "#30B39F",
  tertiaryDark: "#238a7a",
  tertiaryLight: "#3edec5",

  tertiaryContrast: "#c9e9e1",
  tertiaryContrastLight: "#edf8f5",

  // Quaternary
  quaternary: "#FEA530",
  quaternaryDark: "#cd820f",
  quaternaryLight: "#fed9c0",

  quaternaryContrast: "#ffeedb",
  quaternaryContrastLight: "#fff6ed",

  // Quintary
  quinary: "#F63F3C",
  quinaryDark: "#be201d",
  quinaryLight: "#f88c8b",

  quinaryContrast: "#fbc5c5",
  quinaryContrastLight: "#fedcdc",

  // Background
  background: "#F7F9FD",
  backgroundDark: "#dcdee1",
  backgroundDarker: "#a3a5a7",
  backgroundLight: "#f9fafe",
  backgroundLighter: "#FFFFFF",

  backgroundContrast: "#2B233B",
  backgroundContrastDark: "#140C25",
  backgroundContrastLight: "#676275",

  // Success
  success: "#30B39F",
  successContrast: "#D7FFF7",

  // Error
  error: "#ED8C8B",
  errorContrast: "#FBDBDB",
  errorContrastLight: "#fef0f0",

  // Trial Colors
  trialYellow: "#FFE4B1",
  trialOrange: "#FFCCB1",
  trialOnHold: "#CBDBF2",
  trialDarkOrange: "#FFB1B1",
  subscriptionRunningEnterprise: "#7A79B1",
  subscriptionRunning: "#D7E5FA",
};

export const color = {
  primary: "#ED8C8C",
  primaryLight: "#FCEEE8",
  secondary: "#40A2B2",
  secondaryLight: "#EBF5F7",
  tertiary: "#FFE4B1",
  tertiaryDark: "#BF8B2C",
  tertiaryLight: "#FBF0DB",
  quaternary: "#6194E0",
  quaternaryLight: "#E8EFFB",
  quinary: "#3EB8A0",
  quinaryLight: "#E2F5F1",
  senaryLight: "#F5F8FD",
  red: "red",
  black: "#000000",
  dawnPink: "#E8E7E9",
  bmdPurple: "#7A79B1",
  bmdPurpleLight: "#DADAE8",
  bmdPurleDark: "#525098",
  bmdRed: "#ED4949",
  bmdRedLight: "#F7D6D6",
  bmdRedDark: "#DC3232",

  dark: "#2B233B",
  darker: "#140C25",
  white: "white",
  whiteLight: "#F8F7F7",
  greyLightest: "#EFEFEF",
  greyLighter: "#F5F5F4",
  greyLight: "#E0E0E0",
  greyChateau: "#A0A5BC",
  greySelected: "#B9B9B9",
  grey: "#999",
  alto: "#DCDCDC",

  transparent: "transparant",
  background: "#F7F9FD",
  transparentBackground: "rgba(0, 0, 0, 0.2)",

  bmdBlue: "#6194E0",

  reservationHome: "#575690",
  reservationVisitor: "#7A79B1",
  reservationOther: "#FF9552",
  activeTable: "#DFEAF9",
  hoverTable: "#F0F0F0",
};

export const text = {
  tiny: {
    size: "10px",
    lineHeight: "22px",
  },
  extraSmall: {
    size: "13px",
    lineHeight: "36px",
  },
  extraSmallGood: {
    size: "13px",
    lineHeight: "18px",
  },
  small: {
    size: "14px",
    lineHeight: "20px",
  },
  medium: {
    size: "16px",
    lineHeight: "36px",
  },
  large: {
    size: "20px",
  },
  larger: {
    size: "26px",
  },

  big: {
    size: "30px",
  },
  extraLarge: {
    size: "36px",
  },
};

export const borderRadius = {
  small: "5px",
  tiny: "8px",
  medium: "10px",
  large: "15px",
  extraLarge: "20px",
  full: "9999px",
};

export const borderWidth = {
  small: "1px",
  medium: "2px",
};

export const boxShadow = {
  small: `
      shadow-radius: 4px;
      shadow-offset: 0 2px;
      shadow-color: black;
      shadow-opacity: .15;
    `,
  medium: `
      shadow-radius: 4px;
      shadow-offset: 0 2px;
      shadow-color: black;
      shadow-opacity: .5;
    `,
  extreme: `
    shadow-radius: 6px;
    shadow-offset: 0 4px;
    shadow-color: black;
    shadow-opacity: .2;
  `,
};

export const breakpoint = {
  mobile: 992,
  tablet: 1024,
  desktop: 1200,
};

export const nav = {
  avatarSize: "46px",
  logoWidth: "82px",
  logoHeight: "46px",
};

export const iconSize = {
  extraSmall: `
  width: 13px;
  height: 13px;
`,
  small: `
  width: 18px;
  height: 18px;
`,
  medium: `
  width: 24px;
  height: 24px;
`,
  large: `
  width: 39px;
  height: 39px;
`,
  extraLarge: `
  width: 65px;
  height: 65px;
`,
};

export const button = {
  paddingSmall: "14px",
  padding: "28px",
  height: "46px",
};

export const badge = {
  extraSmall: {
    size: "32px",
  },
  small: {
    size: "36px",
  },
  medium: {
    size: "40px",
  },
};

export const dot = {
  small: {
    size: "8px",
  },
};

export const chevron = {
  width: "10px",
  height: "6px",
};

export const input = {
  height: "46px",
};

export const cursor = {
  pointer: "pointer",
};

export const TextAlign = {
  center: "center",
  left: "left",
  right: "right",
};

export const flex = {
  justifyContent: {
    center: "center",
    spaceBetween: "space-between",
    flexEnd: "flex-end",
  },
  direction: {
    row: "row",
    column: "column",
  },
};

export const padding = {
  small: "10px",
};

export const display = {
  none: "none",
  block: "block",
  inline: "inline",
  flex: "flex",
};

export const whiteSpace = {
  nowrap: "nowrap",
};

export const margin = {
  small: "10px",
  medium: "20px",
  large: "30px",
};

export const opacity = {
  default: "1",
  disabled: "0.6",
};

export enum Position {
  fixed = "fixed",
  absolute = "absolute",
  relative = "relative",
  sticky = "sticky",
}

export enum Overflow {
  scroll = "scroll",
  auto = "auto",
}
